module.exports = __webpack_public_path__ + "officialStatic/img/detail-self1.6f1e86f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-self1.png
// module id = k9Id
// module chunks = 0